import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LOAD_DOCUMENTS } from "@Client/@Modules/documents/store/document-actions";
import { mapActions, mapState } from "vuex";
import { filter } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "OutstandingDocuments",
  data() {
    return {
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["selectedApplicationId"])), mapState("DocumentStore", ["classifications", "documents"])), {}, {
    outstandingDocs() {
      const classifications = this.classifications.byApplication[this.selectedApplicationId].byId;
      return filter(classifications, ({
        sent,
        documents,
        requestedFromApplicant
      }) => sent && requestedFromApplicant && (documents.length === 0 || documents.some(documentId => {
        const {
          requestStatus
        } = this.documents.byApplication[this.selectedApplicationId].byId[documentId];
        return requestStatus === "outstanding";
      })));
    }
  }),
  async mounted() {
    this.loading = true;
    await this.LOAD_DOCUMENTS({
      applicationId: this.selectedApplicationId
    });
    this.loading = false;
  },
  methods: _objectSpread({}, mapActions("DocumentStore", [LOAD_DOCUMENTS]))
});